import React from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import GooglePlayDownload from '../../img/playstore.svg'
import AppStoreDownload from '../../img/applestroe.svg'
import AppImage from '../../img/trippie-air-phone-display.png'

export default function Home(){
  return(
    <div className="home">
      <Helmet>
        <title>Trippie Air - Home</title>
        <meta name="description" content="Trippie Air" />
      </Helmet>
      <div className="home-hero bg-gradient">
        <div className="container-middle-content">
          <div className="home-header-text">
            <h1 className="medium-heading">Welcome to Trippie where we connect Drivers to people in need of
            delivering an item within the United Arab Emirates (UAE)!</h1>
            <p className="medium-para">
            Have you been looking for an alternative way of sending packages to friends and family
            across the UAE. Are you looking for a cheaper option? Maybe a more personal option, or
            even a more environmentally friendly option? Here at Trippie that is exactly what we aim to
            provide. Maybe you are a business or a person always sending items from one place to
            another. Well here at Trippie we help you deliver items including letters, parcels and food in
            a cost effective manner.
            </p>
            <div className="new-links mt-5">
            <NavLink to="#" className="signup-link-btn">
              <span className="signup-icon">🏢</span>
              Register Your Business – Start Delivering Smarter
            </NavLink>
            <NavLink to="#" className="signup-link-btn">
              <span className="signup-icon">📦</span>
              Send a Package – Sign Up as a Customer
            </NavLink>
            <NavLink to="#" className="signup-link-btn">
              <span className="signup-icon">🚚</span>
              Become a Delivery Partner – Sign Up to Drive
            </NavLink>
          </div>
        </div>
        </div>
      </div>
      <div className="container-middle-content">
        <div className="information-box">
          <div className="information-row">
            <div className="information-cell">
              <i className="fas fa-truck"></i>
              <div className="info-text">
                <h1 className="small-heading text-align-center">
                  Distance Delivery
                </h1>
                <p className="small-para">
                Trippie is an exciting new delivery service app that connects customers who have items they need delivered with service providers who have the means and opportunity to transport your package.
                </p>
              </div>
            </div>
            <div className="information-cell">
              <i className="fas fa-users"></i>
              <div className="info-text">
                <h1 className="small-heading">
                  Community based service
                </h1>
                <p className="small-para">
                Trippie aims to be community based delivery drivers using our fleet.
                </p>
              </div>
            </div>
            <div className="information-cell">
              <i className="fas fa-comments-dollar"></i>
              <div className="info-text">
                <h1 className="small-heading">
                  Competitive Pricing
                </h1>
                <p className="small-para">
                Trippie uses on demand business model. This means we can keep operating costs very low because we do not maintain a fleet of vehicles rather service providers are able to deal with delivery requests efficiently
                </p>
              </div>
            </div>
          </div>
          <div className="information-row">
            <div className="information-cell">
              <i className="fas fa-mobile-alt"></i>
              <div className="info-text">
                <h1 className="small-heading">
                  Easy to use app
                </h1>
                <p className="small-para">
                Trippie takes a modern approach to the user experience, aiming to make all aspects of the
                app easy to use for the users benefit.
                </p>
              </div>
            </div>
            <div className="information-cell">
              <i className="fas fa-leaf"></i>
              <div className="info-text">
                <h1 className="small-heading">
                  Environmentally friendly
                </h1>
                <p className="small-para">
                Trippie to assist in the growing issue of environmental impact. Using the same area pickup &amp;
delivery model means goods will pass to the driver with less CO<sub>2</sub> emission and packaging
waste.
                </p>
              </div>
            </div>
            <div className="information-cell">
              <i className="fas fa-building"></i>
              <div className="info-text">
                <h1 className="small-heading">
                  Experienced Delivery Service Providers
                </h1>
                <p className="small-para">
                Why not earn money by signing up with Trippie to deliver packages since Trippie connects
                businesses and people who wish to deliver items locally with our drivers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="app-section bg-gradient">
        <div className="container-middle-content">
          <div className="row">
            <div className="med-60">
              <div className="text-housing-download">
                <h1 className="large-heading">Join Trippie</h1>
                <p className="large-para">
                  The Trippie app connects customers with experience delivery service providers, who can
                  take goods across the UAE. Download Trippie today.
                </p>
                <div className="download-container" style={{ display: "flex",  alignItems: "center",gap: "10px" }}>
                <div className="google-play">
                  <a href="#">
                    <img
                      className="download-image"
                      src={GooglePlayDownload}
                      alt="Google Play"
                      style={{ width: "150px", height: "auto",borderRadius: "10px" }}
                    />
                  </a>
                  </div>
                  <div className="apple-store">
                  <a href="#">
                    <img
                      className="download-image"
                      src={AppStoreDownload}
                      alt="Apple Store"
                      style={{ width: "150px", height: "auto",borderRadius: "10px" }}
                    />
                  </a>
                  </div>
                </div>
                </div>
              </div>
              <div className="med-40">
                <img
                  className="app-image"
                  src={AppImage}
                  alt=""
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}

